import type { CSSProperties, ReactNode } from 'react'

interface AlgoBadgeProps {
  children?: ReactNode
  style?: CSSProperties
}

/**
 * "◇ Detected" badge — for rule-based pattern matches.
 * Neutral chrome. Must NOT carry indigo (Rule 07).
 */
export function AlgoBadge({ children = 'Detected', style }: AlgoBadgeProps): JSX.Element {
  return (
    <span
      data-testid="algo-badge"
      data-register="algorithmic"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        height: 18,
        padding: '0 8px',
        borderRadius: 4,
        background: 'rgba(107, 99, 89, 0.10)',
        color: 'var(--text-2)',
        fontFamily: 'var(--font-mono)',
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 9, letterSpacing: 0 }}>◇</span>
      {children}
    </span>
  )
}
